import React, { FC, FocusEvent, ChangeEvent } from 'react';
import { ListFieldProps } from '@sitecore-jss/sitecore-jss-react-forms/types';
import Icon from '../../../@shared/icon';
import useFirstUserAction from '../../hooks/useFirstUserActionState';
import CustomTextLabel from '../@shared/customTextLabel';
const RadioGroup: FC<ListFieldProps> = (props) => {
  const { field, tracker } = props;
  const hasAnyError = !!props.errors?.length;
  const label = field.model.title;
  const id = field.valueField.id;
  const name = field.valueField.name;
  const FieldValidationErrors = props.fieldValidationErrorsComponent;
  const triggerFirstInteractionGTMEvent = useFirstUserAction();
  const getNewValue = (targetValue: string): string[] => [targetValue];
  const onFocus = (e: FocusEvent<HTMLInputElement>): void => {
    tracker.onFocusField(field, getNewValue(e.target?.value));
  };
  const onBlur = (e: FocusEvent<HTMLInputElement>): void => {
    tracker.onBlurField(field, getNewValue(e.target?.value));
  };
  const onChange = (e: ChangeEvent<HTMLInputElement>): void => {
    props.onChange(field.valueField.name, getNewValue(e.target?.value), props.isValid, []);
    triggerFirstInteractionGTMEvent();
  };

  return (
    <div
      className={`sitecore-jss-form__control sitecore-jss-form__control--radio-btn-list ${
        hasAnyError ? 'sitecore-jss-form__control--has-error' : ''
      }`}
    >
      <label className={'sitecore-jss-form__radio-btn-title'} htmlFor={id}>
        {' '}
        <CustomTextLabel label={label} tag="span"/>
      </label>
      <ul>
        {(field?.model?.items || []).map((item) => {
          return (
            <li key={`${item?.itemId}`} className="sitecore-jss-form__radio-btn-wrapper">
              <label>
                <input
                  type="radio"
                  form="novalidatedform"
                  name={name}
                  className="sitecore-jss-form__field"
                  value={item?.value}
                  onFocus={onFocus}
                  onBlur={onBlur}
                  onChange={onChange}
                  checked={props.value.includes(item.value)}
                />
                {props.value.includes(item.value) ? (
                  <Icon iconName="action-radio-checked" size={24} extraClassName="sitecore-jss-form__radio-btn" />
                ) : (
                  <Icon iconName="action-radio-default" size={24} extraClassName="sitecore-jss-form__radio-btn" />
                )}
                <p>
                  <CustomTextLabel label={`${item?.text}`} />
                </p>
              </label>
            </li>
          );
        })}
      </ul>
      {FieldValidationErrors && <FieldValidationErrors {...props} />}
    </div>
  );
};
export default RadioGroup;
